import React, { useState } from 'react';
import logoDark from "../assets/logo7.png"
import barrier from "../assets/barrier.png"

const ExactPhoneMockupInteractive = () => {
  // Төлөвүүд: 'idle' (НЭЭХ), 'searching' (ХАЙЖ БАЙНА), 'found' (ПОПАП), 'success' (АМЖИЛТТАЙ)
  const [appState, setAppState] = useState('idle');

  // 1. Хайх үйлдэл (Хугацааг 0.8s болгож хурдасгав)
  const handleOpenClick = () => {
    if (appState !== 'idle') return; 
    
    setAppState('searching');
    
    setTimeout(() => {
      setAppState('found');
    }, 800); 
  };

  // 2. Хаалт нээх (Popup доторх товч)
  const openBarrier = () => {
    setAppState('success');
  };

  // 3. Буцаад хэвийн төлөвт орох (OK товч)
  const resetApp = () => {
    setAppState('idle');
  };

  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-w-full tw-font-sans tw-py-8">
      
      {/* --- IPHONE PRO HARDWARE FRAME --- */}
      <div className="tw-relative tw-w-[340px] tw-h-[730px] tw-bg-[#1c1d21] tw-rounded-[60px] tw-p-[6px] tw-shadow-[0_25px_50px_-12px_rgba(0,0,0,0.4)] tw-border-[3px] tw-border-[#404247] tw-ring-1 tw-ring-black tw-transform tw-transition-transform tw-duration-500 hover:tw--translate-y-3">
        
        {/* Hardware Buttons */}
        <div className="tw-absolute tw-left-[-7px] tw-top-[120px] tw-w-[4px] tw-h-[26px] tw-bg-[#404247] tw-rounded-l-md tw-border-l tw-border-y tw-border-[#606268]"></div>
        <div className="tw-absolute tw-left-[-7px] tw-top-[170px] tw-w-[4px] tw-h-[55px] tw-bg-[#404247] tw-rounded-l-md tw-border-l tw-border-y tw-border-[#606268]"></div>
        <div className="tw-absolute tw-left-[-7px] tw-top-[240px] tw-w-[4px] tw-h-[55px] tw-bg-[#404247] tw-rounded-l-md tw-border-l tw-border-y tw-border-[#606268]"></div>
        <div className="tw-absolute tw-right-[-7px] tw-top-[190px] tw-w-[4px] tw-h-[80px] tw-bg-[#404247] tw-rounded-r-md tw-border-r tw-border-y tw-border-[#606268]"></div>

        {/* --- INNER SCREEN BEZEL --- */}
        <div className="tw-relative tw-w-full tw-h-full tw-bg-black tw-rounded-[54px] tw-p-[5px] tw-overflow-hidden">
          
          {/* --- ACTUAL APP SCREEN --- */}
          {/* isolation-isolate нь Popup гарч ирэхэд доод булангийн дугуйралтыг хамгаална */}
          <div className="tw-relative tw-w-full tw-h-full tw-bg-[#f6f7f9] tw-rounded-[49px] tw-overflow-hidden tw-flex tw-flex-col tw-isolation-isolate">
            
            {/* Цайвар саарал background glow */}
            <div className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-[300px] tw-bg-gradient-to-b tw-from-[#eef3ea] tw-to-transparent tw-opacity-80"></div>

            {/* --- 1. STATUS BAR & DYNAMIC ISLAND --- */}
            <div className="tw-relative tw-z-40 tw-w-full tw-px-6 tw-pt-3 tw-flex tw-justify-between tw-items-center">
              <div className="tw-text-black tw-font-bold tw-text-[15px] tw-tracking-tight tw-ml-1">
                2:29
              </div>
              
              <div className={`tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-2.5 tw-h-[32px] tw-bg-black tw-rounded-full tw-transition-all tw-duration-500 tw-flex tw-items-center tw-justify-end tw-pr-3 tw-z-50 ${appState === 'searching' ? 'tw-w-[130px]' : 'tw-w-[110px]'}`}>
                {appState === 'searching' && (
                  <>
                    <div className="tw-w-2.5 tw-h-2.5 tw-bg-green-500 tw-rounded-full tw-animate-pulse tw-mr-2"></div>
                    <div className="tw-flex tw-space-x-1">
                      <div className="tw-w-1.5 tw-h-3 tw-bg-blue-500 tw-rounded-full tw-animate-[bounce_1s_infinite]"></div>
                      <div className="tw-w-1.5 tw-h-2 tw-bg-blue-500 tw-rounded-full tw-animate-[bounce_1s_infinite_200ms]"></div>
                      <div className="tw-w-1.5 tw-h-3 tw-bg-blue-500 tw-rounded-full tw-animate-[bounce_1s_infinite_400ms]"></div>
                    </div>
                  </>
                )}
              </div>
              
              <div className="tw-flex tw-items-center tw-space-x-1.5">
                <div className="tw-flex tw-items-end tw-space-x-[1.5px] tw-h-3">
                  <div className="tw-w-[2.5px] tw-h-[4px] tw-bg-black tw-rounded-sm"></div>
                  <div className="tw-w-[2.5px] tw-h-[6px] tw-bg-black tw-rounded-sm"></div>
                  <div className="tw-w-[2.5px] tw-h-[9px] tw-bg-black tw-rounded-sm"></div>
                  <div className="tw-w-[2.5px] tw-h-[12px] tw-bg-black tw-rounded-sm"></div>
                </div>
                <svg className="tw-w-[15px] tw-h-[15px] tw-text-black" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 21L15.6 16.2C14.6 15.4 13.4 15 12 15C10.6 15 9.4 15.4 8.4 16.2L12 21ZM12 4C7.3 4 3.1 5.7 0 8.5L3.6 13.3C5.9 11.2 8.8 10 12 10C15.2 10 18.1 11.2 20.4 13.3L24 8.5C20.9 5.7 16.7 4 12 4Z"></path>
                </svg>
                <div className="tw-relative tw-w-[22px] tw-h-[11px] tw-border tw-border-black tw-rounded-[3px] tw-p-[1px]">
                  <div className="tw-bg-black tw-w-[15px] tw-h-full tw-rounded-[1.5px]"></div>
                  <div className="tw-absolute tw-right-[-3px] tw-top-1/2 tw--translate-y-1/2 tw-w-[2px] tw-h-[4px] tw-bg-black tw-rounded-r-sm"></div>
                </div>
              </div>
            </div>

            {/* --- 2. HEADER --- */}
            <div className="tw-relative tw-z-30 tw-flex tw-justify-between tw-items-center tw-px-5 tw-mt-6">
              <div className="tw-w-[40px] tw-h-[40px] tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-shadow-[0_4px_10px_rgba(0,0,0,0.04)] tw-border tw-border-gray-100">
                <svg className="tw-w-5 tw-h-5 tw-text-gray-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 7h16M4 12h16M4 17h16"/>
                </svg>
              </div>

              <div className="tw-relative tw-flex tw-items-center tw-justify-center">
                 <div className="tw-flex tw-items-center tw-text-[22px]">
                        <img className='tw-h-12' src={logoDark}/>
                </div>
              </div>

              <div className="tw-w-[40px] tw-h-[40px] tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-shadow-[0_4px_10px_rgba(0,0,0,0.04)] tw-border tw-border-gray-100">
                <svg className="tw-w-5 tw-h-5 tw-text-gray-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
                </svg>
              </div>
            </div>

            {/* --- 3. BLACK USER PILL CARD --- */}
            <div className={`tw-relative tw-z-30 tw-mt-8 tw-mx-5 tw-bg-[#222121] tw-p-4 tw-flex tw-flex-col tw-shadow-[0_15px_30px_rgba(70,50,40,0.2)] tw-transition-all tw-duration-500 ${appState === 'success' ? 'tw-rounded-[30px]' : 'tw-rounded-[24px]'}`}>
              <div className="tw-flex tw-items-center tw-justify-between">
                <div className="tw-flex tw-items-center">
                  <div className="tw-w-[42px] tw-h-[42px] tw-bg-[#363535] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3">
                    <svg className="tw-w-[22px] tw-h-[22px] tw-text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                  </div>
                  <div className="tw-flex tw-flex-col tw-justify-center">
                    <div className="tw-flex tw-items-center tw-mb-1">
                      <span className="tw-text-white tw-font-bold tw-text-[15px] tw-tracking-wide">Б***т</span>
                      <svg className="tw-w-3.5 tw-h-3.5 tw-text-gray-400 tw-ml-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                      </svg>
                    </div>
                    <div className="tw-flex tw-items-center tw-text-[#8c8c8c] tw-text-[12px] tw-font-medium">
                      <svg className="tw-w-3.5 tw-h-3.5 tw-mr-1.5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5zM7.5 16c.83 0 1.5-.67 1.5-1.5S8.33 13 7.5 13 6 13.67 6 14.5 6.67 16 7.5 16zm9 0c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5z"/>
                      </svg>
                      91**УБР
                    </div>
                  </div>
                </div>

                {/* Status Badge */}
                <div className={`tw-px-3 tw-py-1.5 tw-rounded-full tw-border tw-flex tw-items-center tw-transition-colors tw-duration-500 ${appState === 'success' ? 'tw-border-green-900 tw-bg-[#203a25]' : 'tw-border-red-900 tw-bg-[#3a2020]'}`}>
                  <div className={`tw-w-1.5 tw-h-1.5 tw-rounded-full tw-mr-1.5 ${appState === 'success' ? 'tw-bg-[#4ade80]' : 'tw-bg-[#ff4b4b]'}`}></div>
                  <span className={`tw-text-[11px] tw-font-bold tw-tracking-wide ${appState === 'success' ? 'tw-text-[#4ade80]' : 'tw-text-[#ff4b4b]'}`}>
                    {appState === 'success' ? 'Зогсоолд' : 'Гадна'}
                  </span>
                </div>
              </div>

              {/* Expanded Info (Only visible in 'success' state) */}
              {appState === 'success' && (
                <div className="tw-bg-[#2c2c2e] tw-rounded-[20px] tw-p-3.5 tw-mt-4 tw-flex tw-items-center tw-justify-between tw-border tw-border-white/5 tw-animate-[fade-in_0.4s_ease-out]">
                  <div className="tw-flex tw-items-center">
                    <div className="tw-w-10 tw-h-10 tw-bg-[#363535] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3">
                      <svg className="tw-w-5 tw-h-5 tw-text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                      </svg>
                    </div>
                    <div>
                      <div className="tw-text-gray-400 tw-text-[9px] tw-font-bold tw-uppercase tw-tracking-widest tw-mb-0.5">Байршил</div>
                      <div className="tw-text-white tw-font-bold tw-text-[13px]">HOME</div>
                    </div>
                  </div>
                  
                  <div className="tw-w-[1px] tw-h-8 tw-bg-gray-600/50 tw-mx-3"></div>
                  
                  <div className="tw-text-right">
                    <div className="tw-text-gray-400 tw-text-[9px] tw-font-bold tw-uppercase tw-tracking-widest tw-mb-0.5">Нэвтэрсэн</div>
                    <div className="tw-text-[#4ade80] tw-font-bold tw-text-[13px]">2026-03-22</div>
                  </div>
                </div>
              )}
            </div>

            {/* --- 4. INTERACTIVE RADAR AREA --- */}
            {appState !== 'success' && (
              <div className="tw-flex-1 tw-relative tw-flex tw-items-center tw-justify-center tw-mb-10">
                
                {/* Radar Rings */}
                {appState === 'searching' && (
                  <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
                    <div className="tw-absolute tw-w-[260px] tw-h-[260px] tw-rounded-full tw-border-[1.5px] tw-border-[#cce8ff] tw-bg-[#f0f7ff]/30 tw-animate-[ping_2.5s_cubic-bezier(0,0,0.2,1)_infinite]"></div>
                    <div className="tw-absolute tw-w-[190px] tw-h-[190px] tw-rounded-full tw-border-[2px] tw-border-[#8bc7ff] tw-bg-[#dcf0ff]/40 tw-animate-[ping_2.5s_cubic-bezier(0,0,0.2,1)_infinite]" style={{ animationDelay: '800ms' }}></div>
                    <div className="tw-absolute tw-w-[140px] tw-h-[140px] tw-rounded-full tw-border-[4px] tw-border-[#00c3ff] tw-bg-gradient-to-tr tw-from-[#00c3ff] tw-to-[#007bff] tw-opacity-20 tw-blur-[2px] tw-animate-[ping_2.5s_cubic-bezier(0,0,0.2,1)_infinite]" style={{ animationDelay: '1600ms' }}></div>
                  </div>
                )}

                {/* Glowing Base */}
                {appState === 'searching' && (
                  <div className="tw-absolute tw-w-[140px] tw-h-[140px] tw-rounded-full tw-border-[4px] tw-border-[#00c3ff] tw-shadow-[0_0_20px_rgba(0,195,255,0.5)] tw-transition-opacity tw-duration-500"></div>
                )}

                {/* The Central Action Button */}
                <div 
                  onClick={handleOpenClick}
                  className={`tw-relative tw-z-10 tw-w-[125px] tw-h-[125px] tw-bg-white tw-rounded-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all tw-duration-500 tw-ease-out
                    ${appState === 'idle' ? 'tw-shadow-[0_15px_35px_rgba(0,0,0,0.1)] hover:tw-scale-105 active:tw-scale-95' : ''}
                    ${appState === 'searching' ? 'tw-shadow-[0_0_20px_rgba(0,150,255,0.2)] tw-scale-95' : ''}
                  `}
                >
                  {appState === 'idle' && (
                    <>
                     <div className="tw-relative tw-w-[34px] tw-h-[34px] tw-mb-2">
                       <img src={barrier}/>
                       
                      </div>
                      <span className="tw-text-[#007aff] tw-font-extrabold tw-text-[10px] tw-tracking-wider tw-animate-pulse">ХАЙХ</span>
                    </>
                  )}

                  {appState === 'searching' && (
                    <>
                      <div className="tw-relative tw-w-[34px] tw-h-[34px] tw-mb-2">
                         <img src={barrier}/>
                      </div>
                      <span className="tw-text-[#007aff] tw-font-extrabold tw-text-[10px] tw-tracking-wider tw-animate-pulse">ХАЙЖ БАЙНА</span>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* --- 5. SUCCESS CARD --- */}
            {appState === 'success' && (
              <div className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-px-5 tw-py-5 tw-pb-5 tw-z-40">
                <div className="tw-w-full tw-bg-[#222121] tw-rounded-[32px] tw-p-4 tw-flex tw-flex-col tw-items-center tw-shadow-[0_20px_50px_rgba(0,0,0,0.25)] tw-animate-[scale-up_0.3s_ease-out]">
                  
                  {/* Green Checkmark & Glow */}
                  <div className="tw-relative tw-mb-8 tw-mt-4">
                     <div className="tw-absolute tw-inset-0 tw-bg-[#22c55e] tw-rounded-full tw-blur-xl tw-opacity-50"></div>
                     <div className="tw-relative tw-w-[80px] tw-h-[80px] tw-bg-[#22c55e] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-shadow-[0_0_40px_rgba(34,197,94,0.4)]">
                        <svg className="tw-w-10 tw-h-10 tw-text-white" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/></svg>
                     </div>
                  </div>
                  
                  <h3 className="tw-text-white tw-text-[22px] tw-font-extrabold tw-tracking-[0.1em] tw-mb-4">АМЖИЛТТАЙ</h3>
                  <p className="tw-text-gray-300 tw-text-center tw-text-[14px] tw-leading-relaxed tw-mb-10">Тавтай морил!<br/>Хаалт амжилттай нээгдлээ.</p>

                  <button 
                    onClick={resetApp} 
                    className="tw-w-full tw-bg-[#363535] hover:tw-bg-[#404040] tw-text-white tw-font-bold tw-py-4 tw-rounded-[20px] tw-transition-colors active:tw-scale-95 tw-shadow-md">
                    OK
                  </button>
                </div>
              </div>
            )}

            {/* --- 6. BOTTOM STATUS BAR --- */}
            {(appState === 'idle' || appState === 'searching') && (
              <div className="tw-absolute tw-bottom-8 tw-left-6 tw-right-6 tw-bg-white tw-px-5 tw-py-4 tw-rounded-[20px] tw-shadow-[0_10px_30px_rgba(0,0,0,0.08)] tw-border tw-border-slate-100 tw-flex tw-items-center tw-justify-between tw-z-20">
                <div className="tw-flex tw-items-center">
                  <div className="tw-w-3 tw-h-3 tw-rounded-full tw-mr-3 tw-bg-[#84b2ff]"></div>
                  <span className="tw-text-[15px] tw-font-extrabold tw-text-slate-800">Хаалт 1</span>
                </div>
                
                <div className="tw-px-3.5 tw-py-2 tw-rounded-xl tw-flex tw-items-center tw-bg-[#eff5ff] tw-text-[#2563eb]">
                  <span className="tw-text-[11px] tw-font-bold tw-tracking-wide tw-uppercase">
                    {appState === 'idle' ? 'Ойрхон байна' : 'Уншиж байна...'}
                  </span>
                </div>
              </div>
            )}

            {/* --- 7. POPUP MODAL --- */}
            {appState === 'found' && (
              <div className="tw-absolute tw-inset-0 tw-z-50 tw-bg-black/30 tw-backdrop-blur-[2px] tw-flex tw-items-end tw-rounded-b-[49px]">
                  <div className="tw-w-full tw-bg-[#1c1c1e] tw-rounded-t-[40px] tw-rounded-b-[49px] tw-p-6 tw-pb-8 tw-shadow-[0_-20px_50px_rgba(0,0,0,0.5)] tw-animate-[slide-up_0.3s_ease-out]">
                      
                      {/* Swipe Handle & VIP Tag */}
                      <div className="tw-flex tw-flex-col tw-items-center tw-mb-5">
                          <div className="tw-w-10 tw-h-1.5 tw-bg-white/20 tw-rounded-full tw-mb-4"></div>
                          <div className="tw-px-4 tw-py-1 tw-bg-gradient-to-r tw-from-yellow-600/20 tw-to-yellow-500/10 tw-border tw-border-yellow-500/30 tw-rounded-full tw-flex tw-items-center">
                              <span className="tw-text-yellow-500 tw-text-[11px] tw-font-extrabold tw-tracking-widest">VIP</span>
                          </div>
                      </div>

                      <h3 className="tw-text-white tw-text-center tw-text-[22px] tw-font-bold tw-mb-6">Миний зогсоол</h3>

                      {/* Announcement box */}
                      <div className="tw-bg-[#2c2c2e] tw-rounded-2xl tw-p-4 tw-mb-4 tw-border tw-border-white/5">
                          <div className="tw-flex tw-items-start">
                              <div className="tw-text-yellow-500 tw-mr-3 tw-text-lg">📢</div>
                              <div>
                                  <div className="tw-text-yellow-500 tw-text-[12px] tw-font-bold tw-mb-0.5 uppercase tw-tracking-wider">Зогсоолын мэдэгдэл</div>
                                  <div className="tw-text-gray-300 tw-text-[13px] tw-leading-snug">Сайн байна уу? Тавтай морилно уу. Зөвхөн зориулалтын зогсоолд байрлуулна уу.</div>
                              </div>
                          </div>
                      </div>

                      {/* Car Plate Info */}
                      <div className="tw-bg-[#2c2c2e] tw-rounded-2xl tw-p-4 tw-mb-6 tw-flex tw-items-center tw-justify-between tw-border tw-border-white/5">
                          <div className="tw-flex tw-items-center">
                              <div className="tw-w-12 tw-h-12 tw-bg-white/5 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mr-4 tw-border tw-border-white/10">
                                  <svg className="tw-w-6 tw-h-6 tw-text-gray-300" fill="currentColor" viewBox="0 0 24 24"><path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5zM7.5 16c.83 0 1.5-.67 1.5-1.5S8.33 13 7.5 13 6 13.67 6 14.5 6.67 16 7.5 16zm9 0c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5z"/></svg>
                              </div>
                              <div>
                                  <div className="tw-text-gray-500 tw-text-[11px] tw-font-semibold uppercase tw-mb-0.5">Машины дугаар</div>
                                  <div className="tw-text-white tw-text-[18px] tw-font-extrabold tw-tracking-wide">91**УБР</div>
                              </div>
                          </div>
                      </div>

                      {/* ACTION BUTTON */}
                      <button 
                          onClick={openBarrier}
                          className="tw-w-full tw-bg-gradient-to-r tw-from-[#22c55e] tw-to-[#16a34a] tw-text-white tw-font-black tw-py-4 tw-rounded-[20px] tw-text-[13px] tw-tracking-wider tw-shadow-[0_10px_25px_rgba(34,197,94,0.4)] active:tw-scale-95 tw-transition-all tw-mb-3">
                          ХААЛТ НЭЭХ
                      </button>

                      <button 
                          onClick={resetApp}
                          className="tw-w-full tw-text-gray-500 hover:tw-text-white tw-font-bold tw-text-[14px] tw-py-2 tw-transition-colors">
                          Цуцлах
                      </button>
                  </div>
              </div>
            )}

            {/* --- 8. HOME INDICATOR --- */}
            <div className={`tw-absolute tw-bottom-2 tw-left-1/2 tw--translate-x-1/2 tw-w-[120px] tw-h-[4px] tw-rounded-full tw-z-[60] tw-transition-colors tw-duration-300 ${appState === 'found' || appState === 'success' ? 'tw-bg-white/50' : 'tw-bg-black'}`}></div>
            
          </div>
        </div>
      </div>

      {/* CSS Animations */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes slide-up {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes scale-up {
          from { transform: scale(0.95); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}} />
    </div>
  );
};

export default ExactPhoneMockupInteractive;